import { render, staticRenderFns } from "./dashboardOrcamentoFuncoesGoverno.vue?vue&type=template&id=5df7f0a4&"
import script from "./dashboardOrcamentoFuncoesGoverno.vue?vue&type=script&lang=js&"
export * from "./dashboardOrcamentoFuncoesGoverno.vue?vue&type=script&lang=js&"
import style0 from "./dashboardOrcamentoFuncoesGoverno.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports